import { render, staticRenderFns } from "./AppealReviewPage.vue?vue&type=template&id=4b7b507c&scoped=true"
import script from "./AppealReviewPage.vue?vue&type=script&lang=js"
export * from "./AppealReviewPage.vue?vue&type=script&lang=js"
import style0 from "./AppealReviewPage.vue?vue&type=style&index=0&id=4b7b507c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b507c",
  null
  
)

export default component.exports